import React, {useRef} from 'react';
import {Badge, Chip} from '@material-ui/core';
import * as classnames from 'classnames';
import {makeStyles} from '@material-ui/styles';
import {styles} from './styles';

const badgeProps = {
    max: 999,
    anchorOrigin: {
        horizontal: 'left',
        vertical: 'top',
    },
    size: 'small',
    color: 'secondary'
};

const useStyles = makeStyles(styles);

function ChartLegend({rightIcon, ...props}) {
    const classes = useStyles();
    const badgeRef = useRef();

    return <Badge overlap="rectangular"
                  {...badgeProps}
                  badgeContent={![null, undefined, NaN].includes(props.content) ? props.content + ' h' : ''}
                  className={classnames(classes.badgeLegend, props.color)} ref={badgeRef}>
        {
            <Chip variant="outlined" color="default" className={classes.chartLegend}
                  size="small"
                  label={<span style={{paddingLeft: badgeRef.current?.querySelector('.MuiBadge-badge').offsetWidth ?? 20}}>{props.label}</span>}
                  {...rightIcon ? {
                      onDelete: () => {
                      }, deleteIcon: rightIcon
                  } : {}}
            />
        }
    </Badge>;
}
export default ChartLegend
